import React from 'react';
import Select from 'react-select';
import { timeOptions } from '../../../constants';
import DeleteIcon from '../../../svg/DeleteIcon';

const customStyles = {
    container: (provided) => ({
        ...provided,
        minWidth: '80px',
        maxWidth: '80px',
    }),
    control: (provided) => ({
        ...provided,
        borderRadius: '6px',
        minHeight: '40px',
    }),
    indicatorsContainer: () => ({
        display: 'none',
    }),
    singleValue: (provided) => ({
        ...provided,
        display: 'flex',
        justifyContent: 'center',
    }),
    menu: (provided) => ({
        ...provided,
        width: '90px'
    })
};

export const TimeRangePicker = ({
    startTime,
    endTime,
    onStartTimeChange,
    onEndTimeChange,
    onRemove,
    error
}) => {
    return (
        <div className="mb-3">
            <div className="d-flex gap-2 align-items-center">
                <div className="d-flex flex-wrap align-items-center gap-1 mb-2">
                    <Select
                        value={timeOptions.find(option => option.value === startTime)}
                        onChange={onStartTimeChange}
                        options={timeOptions}
                        className="w-25"
                        styles={customStyles}
                        maxMenuHeight={200} 
                    />

                    <span className="text-muted">-</span>

                    <Select
                        value={timeOptions.find(option => option.value === endTime)}
                        onChange={onEndTimeChange}
                        options={timeOptions}
                        className="w-25"
                        styles={customStyles}
                        maxMenuHeight={200}
                    />
                </div>

                <button
                    onClick={onRemove}
                    className="btn btn-link text-danger p-0 mb-1"
                >
                    {/* <i className="bi bi-x-circle"></i> */}
                    <DeleteIcon fill="#ff0000" width={14} height={14} />
                </button>
            </div>
            {error && (
                <div className="text-danger small ms-2">{error}</div>
            )}
        </div>
    );
};
